// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2342":"22c1d713","4084":"25226213"}[chunkId] + ".css";
};